import { useIntl } from '@services/i18n';
import PublicHomeView from "@views/PublicHomeView.vue";
import { configureRouter } from "@/.shared/services/routing-services";
import Home from "@/views/AuthorizedHomeView.vue";
import { useAuthentication } from "@/.shared/services/auth";
import ZonasAdministracionView from "@/views/ZonasAdministracionView.vue";
import InstalacionesAdministracionView from "@/views/InstalacionesAdministracionView.vue";
import OscilosView from "@/views/OscilosView.vue";
import OscilosAdministracionView from "@/views/OscilosAdministracionView.vue";
import OsciloDetalleView from "@/views/OsciloDetalleView.vue";
import SucesoDetalleView from "@/views/SucesoDetalleView.vue";
import UsuariosAdministracionView from "@/views/UsuariosAdministracionView.vue";
import WikiView from "@/views/WikiView.vue";
import FicheroMedidaDetalleView from "@/views/FicheroMedidaDetalleView.vue";
import AdministracionView from '@/views/AdministracionView.vue';
import HelpView from '@/components/help/HelpView.vue';
import { PermissionsApp } from '@/.shared/services/auth/authorization';


export function configureAppRoutes() {
  configureRouter((router) => {
    router.addRoute("home", (b) =>
      b
        .withPath("")
        .withComponent(PublicHomeView)
        .allowAnonymous()
        .configure((r) => {
          r.beforeEnter = async (to, from, next) => {
            if (useAuthentication().isLoggedIn()) {
              return next({ name: "private-home" });
            }

            next();
          };
        })
    );

    router.addRoute("private-home", (d) => {
      d.withPath("home")
        .withComponent(Home)
        .withAuthorization({})
        .configure((r) => {
          r.redirect = "/oscilos";
        });
    });

    router.beforeEach((to, from, next) => 
    { 
      const intl = useIntl();
      let title = intl.i18n.t('app_name');
      if (to.meta.titleKey != null)
        title = `${title} - ${intl.i18n.t(to.meta.titleKey as string)}`;
      document.title = title;
      next(); 
    });

    // Oscilos:
    router.addRoute("oscilos-view", (d) => {
      d.withPath("oscilos")
       .withComponent(OscilosView)
       .withAuthorization({authReqs: [PermissionsApp.PortalVisorOscilos]})
       .withTitleKey('pestanas_navegador.titles.oscilos_view');
    });

    router.addRoute("oscilo-detalle-view", (d) => {    
      d.withPath("oscilos/:id/detalle")
      .withComponent(OsciloDetalleView)
      .withAuthorization({authReqs: [PermissionsApp.OscilosVer]})
      .withTitleKey('pestanas_navegador.titles.oscilo_detalle_view');
    });

    // Sucesos:
    router.addRoute("wiki-view", (d) => {
      d.withPath("sucesos/wiki")
       .withComponent(WikiView)
       .withAuthorization({authReqs: [PermissionsApp.PortalWikiSucesos]})
       .withTitleKey('pestanas_navegador.titles.wiki_view');
    });

    router.addRoute("suceso-detalle-view", (d) => {    
      d.withPath("sucesos/:id/detalle")
       .withComponent(SucesoDetalleView)
       .withAuthorization({authReqs: [PermissionsApp.SucesosVer]})
       .withTitleKey('pestanas_navegador.titles.suceso_detalle_view');
    });

    // Ficheros de medida:
    router.addRoute("fichero-medida-detalle-view", (d) => {
      d.withPath("ficheros-medida/:id/detalle")
       .withComponent(FicheroMedidaDetalleView)
       .withAuthorization({authReqs: [PermissionsApp.FicherosMedidaVer]})
       .withTitleKey('pestanas_navegador.titles.fichero_medida_detalle_view');
    });

    // Administración:
    router.addRoute("administracion-view", (d) => {
      d.withPath("administracion").withComponent(AdministracionView).withAuthorization({authReqs: [PermissionsApp.PortalAdministracion]})
       // Zonas:
       .withChild("zonas-administracion-view", (x) =>
       {
          x.withPath("zonas")
           .withComponent(ZonasAdministracionView)
           .withAuthorization({authReqs: [PermissionsApp.ZonasVer]})
           .withTitleKey('pestanas_navegador.titles.zonas_administracion_view')
       })
       // Instalaciones:
       .withChild("instalaciones-administracion-view", (x) =>
       {
          x.withPath("instalaciones")
           .withComponent(InstalacionesAdministracionView)
           .withAuthorization({authReqs: [PermissionsApp.InstalacionesVer]})
           .withTitleKey('pestanas_navegador.titles.instalaciones_administracion_view')
       })
       // Oscilos:
       .withChild("oscilos-administracion-view", (x) =>
       {
          x.withPath("oscilos")
           .withComponent(OscilosAdministracionView)
           .withAuthorization({authReqs: [PermissionsApp.OscilosVer]})
           .withTitleKey('pestanas_navegador.titles.oscilos_administracion_view')
       })
       // Usuarios:
       .withChild("usuarios-administracion-view", (x) =>
       {
          x.withPath("usuarios")
           .withComponent(UsuariosAdministracionView)
           .withAuthorization({authReqs: [PermissionsApp.UsuariosVer]})
           .withTitleKey('pestanas_navegador.titles.usuarios_administracion_view')
       })
    });
    
    router.addRoute("help-view", (d) => {
      d.withPath("help")
       .withComponent(HelpView)
       .withAuthorization({})
       .withTitleKey('pestanas_navegador.titles.help_view');
    });
  });
}
